import React, { createContext, useContext, useState, useCallback } from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';

const ToastContext = createContext();

export const useToast = () => {
  return useContext(ToastContext);
};

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, variant = 'success') => {
    setToasts((prevToasts) => [
      ...prevToasts,
      { id: Date.now(), message, variant }
    ]);
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  }, []);

  return (
    <ToastContext.Provider value={{ addToast }}>
      {children}
      <ToastContainer position="bottom-end" className="position-fixed p-3">
        {toasts.map((toast) => (
          <Toast key={toast.id} onClose={() => removeToast(toast.id)} bg={toast.variant} delay={3000} autohide>
            <Toast.Header>
            <i className="bi bi-chat-right-dots me-2"></i>
            <strong className="me-auto">Message</strong>
          </Toast.Header>
          <Toast.Body className={toast.variant === 'warning' || toast.variant === 'info' ? 'text-dark' : 'text-white'}>{toast.message}</Toast.Body>
          </Toast>
        ))}
      </ToastContainer>
    </ToastContext.Provider>
  );
};